import { post } from './apiService';
import type { SearchParams } from '../types/search';

function buildQueryString(params: SearchParams): string {
  const parts: string[] = [];
  if (params.page !== undefined) parts.push(`page=${params.page}`);
  if (params.pageSize !== undefined) parts.push(`pageSize=${params.pageSize}`);
  if (params.orderBy) parts.push(`orderBy=${params.orderBy}`);
  if (params.order) parts.push(`order=${params.order}`);
  if (params.startDate) parts.push(`startDate=${encodeURIComponent(params.startDate)}`);
  if (params.endDate) parts.push(`endDate=${encodeURIComponent(params.endDate)}`);
  if (params.expand) parts.push(`expand=${encodeURIComponent(params.expand)}`);
  return parts.length ? `?${parts.join('&')}` : '';
}

export async function search<T>(
  endpoint: string,
  filter: object,
  params: SearchParams = {},
): Promise<T[]> {
  const qs = buildQueryString(params);
  return post<T[]>(`${endpoint}${qs}`, Object.keys(filter).length > 0 ? filter : undefined);
}
